module.exports = __webpack_public_path__ + "img/Zusatzwissen_A.0989f5d6.png";